import React from "react";
import Image from "next/legacy/image";
import {
  RateClassModalContent,
  RateClassModalFooter,
  RateClassModalHeader,
  RateClassModalHeading,
  RateClassModalImgContainer,
  StyledSubmitButton
} from "./rate-class-modal.styles";
import { IRateClassSubmittedProps } from "./rate-class-modal.types";
import { ClassRating } from "constants/rate-classes";
import styled from "styled-components";

const StyledParagraph = styled.p`
  margin: 12px 0;
  font-size: ${({ theme }) => theme.fontSizes.lg};
`;

const RateClassSubmitted: React.FC<IRateClassSubmittedProps> = ({
  onClose,
  selectedRating
}) => {
  return (
    <>
      <RateClassModalHeader>
        <RateClassModalImgContainer height={224} width={224}>
          <Image
            src={
              selectedRating === ClassRating.POSITIVE
                ? "/assets/kelas-live/rate-classes/coco-rating-positive-submit.svg"
                : "/assets/kelas-live/rate-classes/coco-rating-submit.svg"
            }
            layout="fill"
            alt="Coco submit"
          />
        </RateClassModalImgContainer>
      </RateClassModalHeader>
      <RateClassModalContent>
        <RateClassModalHeading fontSize={28}>
          Makasih, CoFriends
        </RateClassModalHeading>
        <StyledParagraph>
          {selectedRating === ClassRating.POSITIVE
            ? "Seneng kalo kamu ngerasa kelasnya seru."
            : "CoLearn akan perbaiki biar kelas selanjutnya lebih seru."}
        </StyledParagraph>
      </RateClassModalContent>
      <RateClassModalFooter>
        <StyledSubmitButton variant="primary" onClick={onClose}>
          {selectedRating === ClassRating.POSITIVE ? "Okedeh 👌" : "Oke"}
        </StyledSubmitButton>
      </RateClassModalFooter>
    </>
  );
};

export default RateClassSubmitted;
